import React from "react";
import Switch from "react-switch";

const Toggle = ({ checked, onChange, onColor = "#3192ff", label, fontColor = "#222" }) => {
    const handleChange = (value) => {
        if (onChange) onChange(value);
    };

    return (
        <div style={{ display: "flex", alignItems: "center", maxWidth: "90vw" }}>
            <Switch
                checked={checked}
                onChange={handleChange}
                offColor="#ccc"
                onColor={onColor}
                uncheckedIcon={false}
                checkedIcon={false}
                handleDiameter={12} // 🔹 menor bolinha
                height={16} // 🔹 altura menor
                width={35} // 🔹 largura menor
            />
            <span style={{ marginLeft: 10, fontWeight: "bold", color: fontColor }}>{label}</span>
        </div>
    );
};

export default Toggle;
